// Define custom SVG marker in the <defs> element
const CustomMarker = () => (
  <svg style={{ position: 'absolute', width: 0, height: 0 }}>
    <defs>
      <marker
        id="customArrow"
        viewBox="0 0 10 10"
        refX="10"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M0,0 L10,5 L0,10 Z" fill="#A9A9A9" />
      </marker>
    </defs>
  </svg>
);

export default CustomMarker;
